<template>
  <div class="plus">
    <div class="container">
      <div class="plus__wrapper">
        <div class="plus__item">
          <img src="@images/plusImage1.png" alt="">
          <div class="plus__item-inner">
            <h6>Quality</h6>
            <p>Excellence, delivered.</p>
          </div>
        </div>
        <div class="plus__item">
          <img src="@images/plusImage2.png" alt="">
          <div class="plus__item-inner">
            <h6>Consultancy</h6>
            <p>Feeling lost? We’ll help.</p>
          </div>
        </div>
        <div class="plus__item">
          <img src="@images/plusImage3.png" alt="">
          <div class="plus__item-inner">
            <h6>24/7 Support</h6>
            <p>Problems wait? We don’t.</p>
          </div>
        </div>
        <div class="plus__item">
          <img src="@images/plusImage4.png" alt="">
          <div class="plus__item-inner">
            <h6>Security</h6>
            <p>Risk-proofed. Guaranteed.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.plus {
  background-image: url(@images/plusBg.png);
  background-position: left 0 top 100px;
  padding-bottom: 60px;

  &__wrapper {
    position: relative;
    z-index: 1;
    margin-top: -125px;
    margin-inline: auto;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 75px;
    padding: 50px 43px;
    border-radius: 12px;
    background-color: $white;
    box-shadow: 0 24px 100px 0 rgba(22, 25, 50, 0.07);
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;

    &-inner {
      display: flex;
      flex-direction: column;
      gap: 6px;

      & h6 {
        color: #272343;
        font-size: 18px;
        font-weight: 500;
        text-transform: capitalize;
      }

      & p {
        color: #9A9CAA;
        font-size: 15px;
        font-weight: 400;
      }
    }
  }
}

@media (max-width: 1600px) {
  .plus {
    &__wrapper {
      gap: unset;
      justify-content: space-between;
    }

    &__item {
      gap: 5px;

      &-inner {
        & h6 {
          font-size: 15px;
        }

        & p {
          font-size: 13px;
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .plus {
    &__wrapper {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      place-items: center;
      row-gap: 20px;
    }
  }
}

@media (max-width: 500px) {
  .plus {
    &__wrapper {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>